import { colord, extend } from 'colord';
import a11yPlugin from 'colord/plugins/a11y';

extend([a11yPlugin]);

// WCAG 2 minimums: normal text (AA), and large/bold text and graphics
export const CONTRAST_TEXT = 4.5;
export const CONTRAST_GRAPHIC = 3;

/**
 * The WCAG contrast ratio of two colours (1–21), or null when either isn't
 * a valid colour. A colour with transparency is judged as it shows on the
 * other one.
 */
export const contrastRatio = (foreground, background) => {
  const fg = colord(foreground || '');
  const bg = colord(background || '');
  if (!fg.isValid() || !bg.isValid()) {
    return null;
  }
  // See-through text: blend it onto the background first
  const { r, g, b, a } = fg.toRgb();
  const back = bg.toRgb();
  const solidFg =
    a < 1
      ? colord({
          r: r * a + back.r * (1 - a),
          g: g * a + back.g * (1 - a),
          b: b * a + back.b * (1 - a),
        })
      : fg;
  return Math.round(solidFg.contrast(bg) * 10) / 10;
};
